module.exports = __webpack_public_path__ + "img/water-energy.126e0561.svg";